export const TOOL_IDS_TO_UNREGISTER = [
  // Genogram-specific tools
  'genogram-color',
  'genogram-text',
  'genogram-create',
  'genogram-delete',
  'genogram-connector',
  'genogram-selection',
  'genogram-movement',
  'genogram-frame',
  'genogram-quick-relate',
  'genogram-person-style',
  'genogram-relationship-edit',
  'genogram-person-schema-edit',
  'genogram-reset-person-style',
  'genogram-culture-tags',
  'genogram-health-tags',
  'genogram-culture-palette',
  // Genogram quick action tools
  'genogram-add-person',
  'genogram-add-partner',
  'genogram-add-child',
  'genogram-add-parent',
  'genogram-add-sibling',
  'genogram-add-child-to-couple',
  'genogram-group-as-siblings',
  'genogram-create-relationship',
  // Universal tools
  'shape-picker',
  'sticky-note',
  'sticky-note-properties',
  'universal-text',
  'comments',
  'frames',
  'pen',
  'delete',
  // Contextual tools
  'universal-delete',
  'copy',
  'connect',
  'shape-switch',
  'shape-color',
  'shape-outline',
  'font-size',
  'font-picker',
  'text-style',
  'text-alignment',
  'text-color',
  'bpmn-event-style',
  'bpmn-event-trigger',
  'bpmn-gateway-type',
  'bpmn-activity-style',
  'bpmn-activity-marker',
  'bpmn-activity-task',
  // Genogram-specific contextual tools
  'person-style',
  'relationship-edit',
  'schema-driven-person',
  'reset-person-style',
  'culture-tag',
  'health-tag',
  'culture-palette',
  // Org chart tools
  'org-add-position',
  'org-reporting',
  'org-add-person',
  'org-occupies',
  'org-add-department',
  'org-connector-edit',
  'orgchart-data',
] as const satisfies readonly string[];

export const TOOL_IDS_TO_PRESERVE_ON_UNMOUNT = new Set<string>([
  'org-add-position',
  'org-reporting',
  'org-add-person',
  'org-occupies',
  'org-add-department',
  'org-connector-edit',
  'orgchart-data',
]);

export const SHORTCUT_IDS_TO_UNREGISTER = [
  // Global undo/redo
  'global-undo',
  'global-undo-cmd',
  'global-redo',
  'global-redo-cmd',
  'global-redo-y',
  // Clipboard
  'edit-cut',
  'edit-cut-cmd',
  'edit-copy',
  'edit-copy-cmd',
  'edit-paste',
  'edit-paste-cmd',
  // Select/delete
  'edit-delete',
  'edit-delete-backspace',
  'edit-select-all',
  'edit-select-all-cmd',
  // Link actions
  'link-open-ctrl',
  'link-open-cmd',
  'link-navigate-back-ctrl',
  'link-navigate-back-cmd',
  // Table ops
  'table-insert-row-below',
  'table-insert-row-below-cmd',
  'table-insert-row-above',
  'table-insert-row-above-cmd',
  'table-insert-col-right',
  'table-insert-col-right-cmd',
  'table-insert-col-left',
  'table-insert-col-left-cmd',
  'table-remove-row',
  'table-remove-row-cmd',
  'table-remove-col',
  'table-remove-col-cmd',
  // Table navigation
  'table-cell-nav-up',
  'table-cell-nav-down',
  'table-cell-nav-left',
  'table-cell-nav-right',
  'table-cell-nav-up-shift',
  'table-cell-nav-down-shift',
  'table-cell-nav-left-shift',
  'table-cell-nav-right-shift',
  'table-cell-edit-enter',
] as const satisfies readonly string[];

